import {
  Youtube,
  Instagram,
  ShoppingBag,
  Mail,
  BookOpen,
  Users,
  Dumbbell,
  Smartphone,
  Calendar,
  Map,
  Headphones,
  Plane,
  GraduationCap,
  Utensils,
  Video,
  ExternalLink,
  Twitter,
  Music2,
  Globe,
  Lock,
  Send
} from "lucide-react";

// OnlyFans icon component - Official Simple Icons SVG
const OnlyFansIcon = ({ className }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className={className}>
    <path d="M24 4.003h-4.015c-3.45 0-5.3.197-6.748 1.957a7.996 7.996 0 1 0 2.103 9.211c3.182-.231 5.39-2.134 6.085-5.173 0 0-2.399.585-4.43 0 4.018-.777 6.333-3.037 7.005-5.995zM5.61 11.999A2.391 2.391 0 0 1 9.28 9.97a2.966 2.966 0 0 1 2.998-2.528h.008c-.92 1.778-1.407 3.352-1.998 5.263A2.392 2.392 0 0 1 5.61 12Zm2.386-7.996a7.996 7.996 0 1 0 7.996 7.996 7.996 7.996 0 0 0-7.996-7.996Zm0 10.394A2.399 2.399 0 1 1 10.395 12a2.396 2.396 0 0 1-2.399 2.398Z"/>
  </svg>
);

// Playboy icon component (bunny silhouette as PNG, white tint)
const PlayboyIcon = ({ className }) => (
  <img
    src="/icons/playboy-bunny.png"
    alt="Playboy"
    className={className}
    style={{ objectFit: "contain", filter: "brightness(0) invert(1)" }}
  />
);

// MYM icon component (mym.fans wordmark — white letters on transparent bg)
const MymIcon = ({ className }) => (
  <img
    src="/icons/mym.png"
    alt="MYM"
    className={className}
    style={{ objectFit: "contain" }}
  />
);


// WhatsApp icon component
const WhatsAppIcon = ({ className }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className={className}>
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/>
  </svg>
);

// Snapchat icon component
const SnapchatIcon = ({ className }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className={className}>
    <path d="M12.206.793c.99 0 4.347.276 5.93 3.821.529 1.193.403 3.219.299 4.847l-.003.06c-.012.18-.022.345-.03.51.075.045.203.09.401.09.3-.016.659-.12.922-.214.14-.05.265-.09.395-.09a.73.73 0 01.315.065c.263.119.39.371.39.654 0 .39-.278.656-.532.801a5.1 5.1 0 01-.535.28c-.136.063-.27.123-.39.18-.35.167-.584.343-.584.63 0 .076.015.15.04.222l.01.023c.202.577.788 1.353 1.594 2.015a7.498 7.498 0 001.89 1.196c.15.074.316.17.316.4 0 .336-.374.507-.6.57-.48.137-1.091.196-1.424.278-.19.047-.31.174-.36.326 0 .006-.003.017-.007.038-.03.159.013.383.073.607.055.204.12.42.12.597 0 .323-.199.559-.558.559a3.52 3.52 0 01-.612-.073 6.6 6.6 0 00-1.246-.135c-.263 0-.516.027-.727.087a4.59 4.59 0 00-.824.375c-.587.33-1.207.675-2.288.675-1.069 0-1.69-.345-2.278-.675a4.554 4.554 0 00-.824-.375 3.39 3.39 0 00-.727-.087c-.474 0-.86.047-1.246.135a3.52 3.52 0 01-.612.073c-.36 0-.558-.236-.558-.559 0-.177.065-.393.12-.597.06-.224.103-.448.073-.607-.004-.02-.007-.032-.007-.037a.401.401 0 00-.36-.327c-.333-.082-.944-.14-1.424-.278-.226-.063-.6-.234-.6-.57 0-.23.166-.326.316-.4a7.498 7.498 0 001.89-1.196c.806-.662 1.392-1.438 1.593-2.015l.01-.024a.534.534 0 00.042-.221c0-.287-.235-.463-.584-.63a7.044 7.044 0 01-.39-.18 5.083 5.083 0 01-.535-.28c-.254-.145-.532-.41-.532-.8 0-.284.127-.536.39-.655a.73.73 0 01.316-.066c.13 0 .255.04.395.09.263.095.623.23.922.214.197 0 .325-.045.4-.09-.007-.165-.017-.33-.029-.51l-.004-.06c-.104-1.628-.23-3.654.3-4.847C7.86 1.069 11.216.793 12.206.793z"/>
  </svg>
);

// TikTok icon component
const TikTokIcon = ({ className }) => (
  <svg 
    viewBox="0 0 24 24" 
    fill="currentColor" 
    className={className}
  >
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z"/>
  </svg>
);

// Pinterest icon component
const PinterestIcon = ({ className }) => (
  <svg 
    viewBox="0 0 24 24" 
    fill="currentColor" 
    className={className}
  >
    <path d="M12 0C5.373 0 0 5.372 0 12c0 5.084 3.163 9.426 7.627 11.174-.105-.949-.2-2.405.042-3.441.218-.937 1.407-5.965 1.407-5.965s-.359-.719-.359-1.782c0-1.668.967-2.914 2.171-2.914 1.023 0 1.518.769 1.518 1.69 0 1.029-.655 2.568-.994 3.995-.283 1.194.599 2.169 1.777 2.169 2.133 0 3.772-2.249 3.772-5.495 0-2.873-2.064-4.882-5.012-4.882-3.414 0-5.418 2.561-5.418 5.207 0 1.031.397 2.138.893 2.738a.36.36 0 0 1 .083.345l-.333 1.36c-.053.22-.174.267-.402.161-1.499-.698-2.436-2.889-2.436-4.649 0-3.785 2.75-7.262 7.929-7.262 4.163 0 7.398 2.967 7.398 6.931 0 4.136-2.607 7.464-6.227 7.464-1.216 0-2.359-.632-2.75-1.378l-.748 2.853c-.271 1.043-1.002 2.35-1.492 3.146C9.57 23.812 10.763 24 12 24c6.627 0 12-5.373 12-12 0-6.628-5.373-12-12-12z"/>
  </svg>
);

// Telegram icon
const TelegramIcon = ({ className }) => (
  <svg 
    viewBox="0 0 24 24" 
    fill="currentColor" 
    className={className}
  >
    <path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z"/>
  </svg>
);

const iconMap = {
  youtube: Youtube,
  instagram: Instagram,
  "shopping-bag": ShoppingBag,
  mail: Mail,
  "book-open": BookOpen,
  users: Users,
  dumbbell: Dumbbell,
  smartphone: Smartphone,
  calendar: Calendar,
  map: Map,
  headphones: Headphones,
  plane: Plane,
  "graduation-cap": GraduationCap,
  utensils: Utensils,
  video: Video,
  tiktok: TikTokIcon,
  twitter: Twitter,
  pinterest: PinterestIcon,
  music: Music2,
  globe: Globe,
  lock: Lock,
  send: TelegramIcon,
  onlyfans: OnlyFansIcon,
  telegram: TelegramIcon,
  playboy: PlayboyIcon,
  mym: MymIcon,
  default: ExternalLink,
};

export const LinkIcon = ({ icon, className = "w-5 h-5" }) => {
  const IconComponent = iconMap[icon] || iconMap.default;
  return <IconComponent className={className} />;
};

export const SocialIcon = ({ platform, className = "w-4 h-4" }) => {
  const icons = {
    instagram: Instagram,
    youtube: Youtube,
    tiktok: TikTokIcon,
    twitter: Twitter,
    pinterest: PinterestIcon,
    onlyfans: OnlyFansIcon,
    telegram: TelegramIcon,
    send: TelegramIcon,
    whatsapp: WhatsAppIcon,
    snapchat: SnapchatIcon,
    playboy: PlayboyIcon,
    mym: MymIcon,
    globe: Globe,
    lock: Lock,
  };
  
  const IconComponent = icons[platform] || Globe;
  return <IconComponent className={className} />;
};

export default LinkIcon;
